import React, { useEffect, useRef, useState } from 'react'
import './rewards.styles.scss'

import { useDispatch, useSelector } from 'react-redux';
import ViewRewardsModal from './view-rewards-modal.component';
import { switchPlayerMenu } from '../side-menu.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import RewardItemUnclicked from './reward-item-unclicked.component';
import RewardItemClicked from './reward-item-clicked.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faBoxOpen, faGem, faGift, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { UseCloudGameTransactions } from '@/utils/firebase.utils';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { get } from 'firebase/database';
import { getActivityRecordsQuery, getGameActivityFromDb } from '@/utils/getDataFromDb';
import { setNewStuffCount } from '@/state/slices/contentSlice';
import { checkForEarnedLevels } from '@/utils/checkForEarnedLevels';

const PlayerRewards = ({ 
    gameData, 
    playerData, 
    updatePlayerData,
    gameElements 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ rewardModalIsOpen, setRewardModalIsOpen ] = useState(false);
    const [ modalActivity, setModalActivity ] = useState(null);
    const [ activityToDisplay, setActivityToDisplay ] = useState(null);
    const [ activityFilter, setActivityFilter ] = useState([]);
    const [ modalHeadText, setModalHeadText ] = useState(null);
    const [ notificationCounts, setNotificationCounts ] = useState(null);
    const [ rewardsToOpen, setRewardsToOpen ] = useState(null);
    const [ viewCategory, setViewCategory ] = useState('reward');
    const [ moreLimit, setMoreLimit ] = useState(12);
    const [ noMore, setNoMore ] = useState(false);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(false);
    const [ clearLoading, setClearLoading ] = useState(false);
    const activityRef = useRef();
    const rewardRef = useRef();
    const approveRef = useRef();
    const viewRef = useRef();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!gameData || !playerData || !viewCategory) {return;}
        // let newActivityObj = {};
        // const content = Object.values(playerActivity)
        // .filter(a => a.display === viewCategory);
        // for (let a of content) {
        //     newActivityObj[a.id] = a;
        // }
        // setActivityToDisplay(newActivityObj)
        if (viewRef.current !== viewCategory) {
            activityRef.current = {};
            viewRef.current = viewCategory;
        }
        getRewardsToDisplay();
    }, [ gameData, playerData, viewCategory ])

    useEffect(() => {
        if (!playerData || !playerData.newStuff) return;
        rewardRef.current = [];
        let countObj = {
            'reward': 0,
            'achievement': 0,
            'prizepack': 0,
            'purchase': 0
        }
        for (let a of playerData.newStuff) {
            countObj[a.display]++
            rewardRef.current.push(a.id);
        }
        setRewardsToOpen([...rewardRef.current]);
        // console.log(countObj);
        setNotificationCounts(countObj);
    }, [playerData])

    useEffect(() => {
        const pageTitle = document.getElementById('page-title');
        if (pageTitle) {
            pageTitle.innerText = 'My Rewards'
        }
        switchPlayerMenu('rewards-btn');
    }, []);

    function getRewardsToDisplay(more) {
        let filter = [{
            'key': 'display',
            'value': viewCategory
        },
        {
            'key': 'playerId',
            'value': playerData.playerId
        }]
        const queryObj = {
            'filter': filter,
            'path': 'activityRecords',
            'gameId': gameData.gameId,
            'limit': moreLimit,
            'once': true,
            'callback': callback
        }
        if (more) {
            // get last entry and add it to queryObj
            queryObj.lastEntry = Object.values(activityRef.current)
            .sort((a,b) => a.ts < b.ts ? 1 : -1)
            [Object.values(activityRef.current).length -1]
        }
        getActivityRecordsQuery(queryObj)
        function callback(data) {
            activityRef.current = {
                ...activityRef.current,
                ...data
            };
            setActivityToDisplay(activityRef.current);
            if (Object.keys(data).length < moreLimit) {
                setNoMore(true);
            } else {
                setNoMore(false);
            }
        }
    }

    async function handleRewardModalOpen(activityId) {
        let tempPlayerData = { ...playerData };

        // launch reward modal
        const act = activityRef.current[activityId];
        setModalActivity(act)
        setModalHeadText(
            act.display === 'prizepack'
            ? 'New '+ act.title + '!'
            : 'Your New Rewards!'
        )
        setRewardModalIsOpen(true);

        // return;

        // if activity is not in newStuff, return
        if (!tempPlayerData.newStuff.find(n => n.id === activityId)) return;

        // save new count of unviewed rewards
        let savedNewStuffCount = Number(window.localStorage.getItem(`${playerData.playerId}_newRewardCount`));
        savedNewStuffCount--;
        window.localStorage.setItem(`${playerData.playerId}_newRewardCount`, savedNewStuffCount);
        dispatch(setNewStuffCount(savedNewStuffCount));

        // Mark the reward as viewed on the server
        
        const timeout = setTimeout(async () => {
            const data = {
                'gameId': gameData.gameId,
                'playerId': playerData.playerId,
                'rewardIdArr': [activityId]
            }
            // console.log(data);

            // Mark the reward as viewed on the client
            tempPlayerData.newStuff = tempPlayerData.newStuff.filter(n => n.id !== activityId);
            updatePlayerData(tempPlayerData);

            const res = await UseCloudGameTransactions('markRewardAsViewed', data)
            // console.log(res);
            if (res.error) {
                setAlertMessage(`Something went wrong. Try again later. (Error: ${res.error})`);
                return;
            }

            // checkForEarnedLevels(gameElements, tempPlayerData, gameData);

            if (act.data && Object.values(act.data).filter(d => d.id === 'xp').length > 0) {
                const els = document.querySelectorAll('.points-div');
                els.forEach(e => {
                    e.classList.add('flash');
                });
            }
            if (act.data && Object.values(act.data).filter(d => d.id === 'currency').length > 0) {
                const els = document.querySelectorAll('.currency-div');
                els.forEach(e => {
                    e.classList.add('flash');
                });
            }
            clearTimeout(timeout);
        }, 2000);

        const ptEls = document.querySelectorAll('.points-div');
        ptEls.forEach(e => {
            e.classList.remove('flash');
        });
        const currencyEls = document.querySelectorAll('.currency-div');
        currencyEls.forEach(e => {
            e.classList.remove('flash');
        });
    }

    function handleRewardModalClose() {
        setRewardModalIsOpen(false)
    }

    async function clearNewRewards() {
        setConfirmMessage('Are you sure you want to open all of the unopened rewards?');
        approveRef.current = () => {
            continueClear();
        }

        async function continueClear() {
            setClearLoading(true);
            const rewardsToClear = [...rewardsToOpen];
            // console.log(rewardsToClear);
            const res = await UseCloudGameTransactions(
                'markRewardAsViewed',
                {
                    'gameId': gameData.gameId,
                    'playerId': playerData.playerId,
                    'rewardIdArr': rewardsToClear,
                }
            )
            // console.log(res);
            setClearLoading(false);
            if (res.error) {
                setAlertMessage(`Something went wrong. Try again later. (Error: ${res.error})`);
                return;
            }
            rewardRef.current = [];
            setRewardsToOpen(rewardRef.current);
        }
    }
    

    return (
        <div className='player-rewards g-card'>
            <div className='player-title'>
                <ImageContainer 
                    src='/images/icons/treasure.png' 
                    alt='rewards icon' 
                    className='player-title-icon' />
                Your Rewards
            </div>
            <hr />
            <div className={`reward-grid ${screenSize}`}>
                <div className='left-menu'>
                    <button 
                        className={`g-button med-btn reward-button ${viewCategory === 'reward' ? 'primary' : ''}`}
                        onClick={() => setViewCategory('reward')}>
                        <div className='notification-with-badge'>
                            <FontAwesomeIcon icon={faGem} />
                            {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Rewards'
                            }
                            {
                                (notificationCounts && notificationCounts.reward > 0) &&
                                <span className="badge">{notificationCounts.reward}</span>
                            }
                        </div>
                    </button>
                    <button 
                        className={`g-button med-btn reward-button ${viewCategory === 'achievement' ? 'primary' : ''}`}
                        onClick={() => setViewCategory('achievement')} >
                        <div className='notification-with-badge'>
                            <FontAwesomeIcon icon={faAward} />
                            {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Achievements'
                            }
                            {
                                (notificationCounts && notificationCounts.achievement > 0) &&
                                <span className="badge">{notificationCounts.achievement}</span>
                            }
                        </div>
                    </button>
                    {
                        (
                            gameData && 
                            gameData.access.includes('prizepacks') &&
                            gameElements &&
                            Object.values(gameElements).filter(e => 
                                e.status === 'active' &&
                                e.opt_itemType === 'prizepack'
                            ).length > 0
                        ) &&
                        <button 
                            className={`g-button med-btn reward-button ${viewCategory === 'prizepack' ? 'primary' : ''}`}
                            onClick={() => setViewCategory('prizepack')} >
                            <div className='notification-with-badge'>
                                <FontAwesomeIcon icon={faGift} />
                                {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Prize Packs'
                            }
                                {
                                    (notificationCounts && notificationCounts.prizepack > 0) &&
                                    <span className="badge">{notificationCounts.prizepack}</span>
                                }
                            </div>
                        </button>
                    }
                    {
                        (gameData.access.includes('store')) &&
                        <button 
                            className={`g-button med-btn reward-button ${viewCategory === 'purchase' ? 'primary' : ''}`}
                            onClick={() => setViewCategory('purchase')} >
                            <div className='notification-with-badge'>
                                <FontAwesomeIcon icon={faShoppingCart} />
                                {
                                (
                                    screenSize !== 'mobile' 
                                ) &&
                                'Your Purchases'
                            }
                                {/* {
                                    (notificationCounts && notificationCounts.prizepack > 0) &&
                                    <span className="badge">{notificationCounts.prizepack}</span>
                                } */}
                            </div>
                        </button>
                    }
                    {
                        (rewardsToOpen && rewardsToOpen.length > 0) &&
                        (
                            (clearLoading) 
                            ?
                            <button className='g-button small-btn'>
                                <ThreeDotsLoader />
                            </button>
                            :
                            <button 
                                className='g-button small-btn open-all-button'
                                onClick={() => clearNewRewards()} >
                                <FontAwesomeIcon icon={faBoxOpen} />
                                {
                                    (
                                        screenSize !== 'mobile' 
                                    ) &&
                                    <div className='meta '>Open All Rewards</div>
                                }
                            </button>
                        )
                    } 
                </div>
                
                <div className='right-col'>
                    {
                        (
                            screenSize === 'mobile' ||
                            screenSize === 'tablet'
                        ) &&
                        <div className='rewards-mobile-head'>
                            <h2>
                            {
                                viewCategory === 'reward' &&
                                'Rewards'
                            }
                            {
                                viewCategory === 'achievement' &&
                                'Achievements'
                            }
                            {
                                viewCategory === 'prizepack' &&
                                'Prize Packs'
                            }
                            {
                                viewCategory === 'purchase' &&
                                'Purchases'
                            }
                            </h2>
                            <hr />
                        </div>
                    }
                    <div className={`reward-list-grid ${screenSize}`}>
                    {
                        (activityToDisplay && playerData) &&
                        Object.values(activityToDisplay)
                        .sort((a,b) => a.ts < b.ts ? 1 : -1)
                        .map(act => (
                            (
                                playerData.newStuff && 
                                playerData.newStuff.find(a => a.id === act.id) &&
                                act.display !== 'purchase'
                            )
                            ?
                            <div key={act.ts} >
                                <RewardItemUnclicked 
                                    reward={act}
                                    gameData={gameData}
                                    playerData={playerData}
                                    handleRewardModalOpen={handleRewardModalOpen} />
                            </div>
                            :
                            <div key={act.ts}>
                                <RewardItemClicked 
                                    reward={act}
                                    handleRewardModalOpen={handleRewardModalOpen} />
                            </div>
                        ))
                    }
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (activityToDisplay) &&
                        <div className='center-col'>
                            <button 
                                className={`g-button med-btn ${noMore ? 'disabled' : ''}`}
                                onClick={() => getRewardsToDisplay(true)}>
                                Load More
                            </button>
                        </div>
                    }
                </div>
            </div>
            <ViewRewardsModal 
                playerData={playerData}
                isOpen={rewardModalIsOpen} 
                onClose={() => handleRewardModalClose()} 
                activity={modalActivity} 
                width={'normal'} 
                closeButton={true}
                modalHeadText={modalHeadText} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default PlayerRewards